import GridItem from "@insite/mobius/GridItem";
import { DealsSectionStyles } from "@nishtech/Components/DealsSectionComponent";
import { ShopSectionStyles } from "@nishtech/Components/ShopSectionComponent";
import { SolutionSectionStyles } from "@nishtech/Components/SolutionAndServicesSectionComponent";
import { MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
import React from "react";

interface OwnProps {
    link: MappedLink;
    styles: DealsSectionStyles | SolutionSectionStyles  | ShopSectionStyles;
}

const PromotionalContentCardDesign: React.FC<OwnProps> = ({ link, styles }): any => {
    const tempDiv = document.createElement("div");

    tempDiv.innerHTML = link?.properties?.promotionalContent;

    const handleClick = () => {
        sessionStorage.setItem("item_list_name", "menu_promo_content");
    };

    return (
        <>
            <GridItem onClick={handleClick} dangerouslySetInnerHTML={{ __html: tempDiv.innerHTML }} {...styles.PromoDangerouslyTag}></GridItem>
        </>
    );
};

export default PromotionalContentCardDesign;
